// src/hooks/useServerStatus.js
import { useEffect, useState } from "react";
import { API } from "../utils/constants";

const POLL_INTERVAL_MS = 30_000; // poll every 30 seconds

export function useServerStatus() {
  const [status, setStatus] = useState({
    discord:   { online: false, memberCount: 0 },
    minecraft: { online: false, playerCount: 0, maxPlayers: 50 },
    loaded: false,
  });

  const fetchStatus = () => {
    fetch(`${API}/status`)
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data) return;
        setStatus({
          discord:   data.discord   || { online: false, memberCount: 0 },
          minecraft: data.minecraft || { online: false, playerCount: 0, maxPlayers: 50 },
          loaded: true,
        });
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  return status;
}
